import { FlatPageFragment } from '@graphql/fragments/__generated__/FlatPage.generated'
import DOMPurify from 'dompurify'
import React from 'react'

interface IPageProps {
  page: FlatPageFragment
}

const Page: React.FC<IPageProps> = ({ page }) => {
  if (!page) return null
  return (
    <div>
      <h1 className='text-xl sm:text-5xl text-center sm:text-left tracking-3/2 font-semibold uppercase mb-12'>
        {page.title}
      </h1>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(page.content),
        }}
      />
    </div>
  )
}

export default Page
